import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import IncomingAlarmListComponent from '../components/incomingAlarmListComponent';
import { getAlarmListFunc, getImageListFunc,getUpdatedAlarmStatusFunc,getAllRegionSettings  } from '../actions/incomingAlarmListAction';

class IncomingAlarmListContainer extends Component {
    
    componentDidMount() {
            /* this.props.actions.getAlarmListFunc(
            this.props.dispatch) */
             this.props.actions.getAllRegionSettings();
    }
    getUserList = (data) =>{
                        this.props.actions.getAlarmListFunc(data,
                            this.props.dispatch
                        )
                    }
    getImageListData = (payload) => {
        this.props.actions.getImageListFunc(
            payload,
            this.props.dispatch
        )
    }
    getAlarmReceiverListData = (payload) => {
        this.props.actions.getUpdatedAlarmStatusFunc(
            payload,
            this.props.dispatch
        )
    }
    getAlarmListFunc= () => {
        this.props.actions.getAlarmListFunc(
            this.props.dispatch)
    }
      getRegionData = () => {
                         this.props.actions.getAllRegionSettings(this.props.dispatch);
                      } 
     getRegionData = () => {
                  this.props.actions.getAllRegionSettings(this.props.dispatch);
               } 
          
            getUserList = (data) =>{
                this.props.actions.getAlarmListFunc(data,
                    this.props.dispatch
                )
            }
            
    render() {
        return (
            <div className="agile-grids">
                                        <div className="grids">
                                            <div className="container">
                                                <div className="row">
                                                   <IncomingAlarmListComponent
                                incomingAlarmList={this.props.incomingAlarmList}
                                getImageListData = {this.getImageListData}
                                getAlarmReceiverListData={this.getAlarmReceiverListData}
                                getAlarmListFunc={this.getAlarmListFunc}
                                   getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
                            />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

           
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAlarmListFunc,
            getImageListFunc,
            getUpdatedAlarmStatusFunc,
            getAllRegionSettings
        }, dispatch)
    };
};

function mapStateToProps({ incomingAlarmListReducer}) {
    console.log(incomingAlarmListReducer);
    return {
        incomingAlarmList: {
                isLoading: incomingAlarmListReducer.isLoading,
                alarmList: incomingAlarmListReducer.alarmList,
                imageList : incomingAlarmListReducer.imageList,
                errorCode: incomingAlarmListReducer.errorCode,
                messageLabel: incomingAlarmListReducer.messageLabel, 
                statusCode: incomingAlarmListReducer.statusCode,
                alarmReceiverList:incomingAlarmListReducer.alarmReceiverList,
                regionList : incomingAlarmListReducer.regionList,
                pageNumber: incomingAlarmListReducer.pageNumber,
                pageSize: incomingAlarmListReducer.pageSize,
                totalRecord: incomingAlarmListReducer.totalRecord
        },
        
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IncomingAlarmListContainer))